export const enum View {
    TABLE,
    EDIT,
    ADD,
    TREATMENT,
}